import { h, reactive, render } from 'vue'
import { useToggle } from 'bootstrap-vue-next'
import ConfirmDialog from '@/components/shared/confirm-dialog.vue'

// bootstrap-vue (Vue 2) exposed this.$bvModal / this.$bvToast and vuejs-dialog exposed this.$dialog.
// bootstrap-vue-next has no instance API, so the same calls are kept here on top of its registry.
export const toasts = reactive({
  shown: {},
  messages: []
})

let nextToastId = 0

export default {
  install(app) {
    const toggle = id => app.runWithContext(() => useToggle(id))
    // a component that is not mounted (v-if) is simply not shown, as with bootstrap-vue
    const ignoreMissing = promise => promise.catch(() => {})

    app.config.globalProperties.$bvModal = {
      show: id => ignoreMissing(toggle(id).show()),
      hide: id => ignoreMissing(toggle(id).hide())
    }

    // v-b-modal.<id>: bootstrap-vue opened the modal on click. bootstrap-vue-next's directive toggles and
    // re-attaches its listener when the element re-renders, so a click whose @click handler changes state
    // (e.g. "add room") never reached it.
    const modalShow = app.config.globalProperties.$bvModal.show
    const showTargets = el => Object.keys(el.bvModalModifiers).forEach(modalShow)
    app.directive('b-modal', {
      mounted(el, { modifiers }) {
        el.bvModalModifiers = modifiers
        el.bvModalListener = () => showTargets(el)
        el.addEventListener('click', el.bvModalListener)
      },
      updated(el, { modifiers }) {
        el.bvModalModifiers = modifiers
      },
      unmounted(el) {
        el.removeEventListener('click', el.bvModalListener)
      }
    })

    app.config.globalProperties.$bvToast = {
      show(id) {
        toasts.shown[id] = 2000
      },

      toast(body, { autoHideDelay = 5000, variant } = {}) {
        toasts.messages.push({ id: nextToastId++, body, variant, shown: autoHideDelay })
      }
    }

    app.config.globalProperties.$dialog = {
      confirm(message, { okText, cancelText }) {
        return new Promise((resolve, reject) => {
          const container = document.createElement('div')
          document.body.appendChild(container)
          const close = settle => () => {
            render(null, container)
            container.remove()
            settle()
          }
          const vnode = h(ConfirmDialog, { message, okText, cancelText, onOk: close(resolve), onCancel: close(reject) })
          vnode.appContext = app._context
          render(vnode, container)
        })
      }
    }
  }
}
